import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppRedirectService } from 'src/app/services/app-redirect.service';
import { TranslationService } from 'src/app/services/translation.service';
import { SharedModule } from 'src/app/share.module';

@Component({
    selector: 'app-app-fallback-redirect',
    standalone: true,
    imports: [SharedModule],
    templateUrl: './app-fallback-redirect.component.html',
    styleUrl: './app-fallback-redirect.component.scss',
})
export class AppFallbackRedirectComponent {
    isLoading: boolean = false;

    constructor(
        private readonly _translationService: TranslationService,
        private readonly _appRedirectService: AppRedirectService,
        private readonly _router: Router,
    ) {}

    ngAfterViewInit(): void {
        this.isLoading = true;
        try {
            this._translationService.getCpSecretsFromKeyVault().subscribe((response: any) => {
                if (response) {
                  const url: string = localStorage.getItem('routeUrl') ?? '/stories';
                  this._router.navigate([url]);
                    this._appRedirectService.getSmartBannerLinks();
                    this.isLoading = false;
                    setTimeout(() => {
                        this._appRedirectService.redirectUserToStoreBasedOnDeviceRegion();
                    }, 100);
                }
            });
        } catch (err) {
            // do something
            this.isLoading = false;
        }
    }
}
